import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Rest as Desc } from './desk'
import { Rest as Mob } from './mob'

type Props = {
  images: TImages
}
export const Rest: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
